// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  margin-bottom: 30px;
  color: #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/Models/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":["label {\n  margin-bottom: 30px;\n  color: #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
